/**
 * Icon-Namen, Texte und Pfade der eigenen SVG-Sammlung (reines TS, auch für Tests).
 */
export const ICON_NAMEN = [
  'cocktail',
  'bier',
  'wein',
  'sekt',
  'flasche',
  'kaffee',
  'saft',
  'wasser',
  'teller',
  'kuchen',
  'geschenk',
  'stern',
] as const;
export type IconName = (typeof ICON_NAMEN)[number];

export const ICON_TEXTE: Record<IconName, string> = {
  cocktail: 'Cocktailglas',
  bier: 'Bierkrug',
  wein: 'Weinglas',
  sekt: 'Sektglas',
  flasche: 'Flasche',
  kaffee: 'Tasse',
  saft: 'Saftglas',
  wasser: 'Wasserglas',
  teller: 'Teller',
  kuchen: 'Kuchen',
  geschenk: 'Geschenk',
  stern: 'Stern',
};

export const ICON_PFADE: Record<IconName, string> = {
  cocktail: 'M3 4h18l-9 10-9-10zM12 14v6M8 20h8M16 7l2-3',
  bier: 'M6 6h9v14H6zM15 9h3a2 2 0 0 1 2 2v4a2 2 0 0 1-2 2h-3M6 6c0-2 2-3 4.5-3S15 4 15 6M9 10v7M12 10v7',
  wein: 'M7 3h10l-1 7a4 4 0 0 1-8 0L7 3zM12 14v6M8 21h8',
  sekt: 'M9 3h6l-1 9a2 2 0 0 1-4 0L9 3zM12 14v6M9 21h6',
  flasche: 'M10 2h4v4l2 3v12a1 1 0 0 1-1 1H9a1 1 0 0 1-1-1V9l2-3V2zM9 13h6',
  kaffee:
    'M4 8h12v6a5 5 0 0 1-5 5H9a5 5 0 0 1-5-5V8zM16 10h2a2 2 0 0 1 0 4h-2M7 5c0-1 1-1 1-2M11 5c0-1 1-1 1-2',
  saft: 'M7 3h10l-1.5 17a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1L7 3zM8 9h8M14 3l4-2',
  wasser: 'M7 3h10l-1.5 17a1 1 0 0 1-1 1h-5a1 1 0 0 1-1-1L7 3zM8.5 12h7',
  teller: 'M3 12a9 9 0 0 1 18 0zM3 12h18M12 3v1M5 16h14',
  kuchen: 'M4 20h16M5 20v-7a7 7 0 0 1 14 0v7M12 3v3M12 6a2 2 0 0 0 2 2M5 15h14',
  geschenk:
    'M3 10h18v11H3zM3 14h18M12 10v11M12 10c-3 0-5-1-5-3s2-3 3-1 2 4 2 4zM12 10c3 0 5-1 5-3s-2-3-3-1-2 4-2 4z',
  stern: 'M12 3l2.7 5.6 6.1.9-4.4 4.3 1 6.1L12 17l-5.4 2.9 1-6.1L3.2 9.5l6.1-.9L12 3z',
};
